import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms17e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms17e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let dteyreap = ''
    let numtime = ''
    let codappr = ''
    let dteappr = ''
    if (typeof searchParams !== 'undefined') {
      dteyreap = (typeof searchParams.year !== 'undefined' ? searchParams.year : '')
      numtime = (typeof searchParams.numtime !== 'undefined' ? searchParams.numtime : '')
      codappr = (typeof searchParams.codempid2 !== 'undefined' ? searchParams.codempid2 : '')
      dteappr = (typeof searchParams.dteappr !== 'undefined' ? searchParams.dteappr : '')
      sendParams = {
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codpos: (typeof searchParams.codpos !== 'undefined' ? searchParams.codpos : ''),
        p_codempid_query: (typeof searchParams.codempid3 !== 'undefined' ? searchParams.codempid3 : '')
      }
    }
    return instance().get(endpoint + '/hrms17e/index/' + dteyreap + '/' + numtime + '/' + codappr + '/' + dteappr.replace(/\//g, ''), { params: sendParams })
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hrms17e/dropdowns')
  },
  getCreate (searchParams) {
    if (isMock) return generator(mocker.create())
    let sendParams = {}
    sendParams = {
      p_codempid_query: searchParams.codempid
    }
    let params = searchParams.p_dteyreap + '/' + searchParams.p_numtime
    return instance().get(endpoint + '/hrms17e/detail1Table/' + params, { params: sendParams })
  },
  getCodempidQuery (codempid) {
    if (isMock) return generator(mocker.codempidQuery())
    const params = codempid
    return instance().get(endpoint + '/hrms17e/codempidQuery/' + params)
  },
  getDetail (editParams) {
    let sendParams = {}
    sendParams = {
      p_codempid_query: editParams.p_codempid_query
    }
    if (isMock) return generator(mocker.detail1())
    let param = editParams.p_dteyreap + '/' + editParams.p_numtime
    return instance().get(endpoint + '/hrms17e/detail1Table/' + param, { params: sendParams })
  },
  getDetail2Create (addParams) {
    if (isMock) return generator(mocker.createDetail2())
    const params = addParams.p_codempid_query + '/' + addParams.p_dteyreap + '/' + addParams.p_numtime
    return instance().get(endpoint + '/hrms17e/detail1Detail1Create/' + params)
  },
  getDetail2 (editParams) {
    if (isMock) return generator(mocker.detail2())
    const params = editParams.p_codempid_query + '/' + editParams.p_dteyreap.replace(/\//g, '') + '/' + editParams.p_numtime + '/' + editParams.p_kpino
    return instance().get(endpoint + '/hrms17e/detail1Detail1/' + params)
  },
  postDetail2Save ({ dataHeader, searchIndex, detail2, detail1Selected }) {
    let sendParams = {
      codcomp: detail2.codcomp,
      codpos: detail2.codpos,
      p_kpiitem: detail2.kpiitem,
      p_kpiwgt: detail2.kpiwgt,
      p_target: detail2.target,
      p_dtetarg: detail2.dtetarg,
      p_mtrunit: detail2.mtrunit,
      p_mtrvalue: detail2.mtrvalue,
      p_codappr: searchIndex.codempid2,
      p_dteappr: searchIndex.dteappr,
      param_tab1: JSON.stringify(detail2.tab1),
      param_tab2: JSON.stringify(detail2.tab2)
    }
    if (isMock) return generator(mocker.save())
    const param = dataHeader.codempid + '/' + searchIndex.year + '/' + searchIndex.numtime + '/' + detail2.kpino
    return instance().post(endpoint + '/hrms17e/detail1Detail1Save/' + param, sendParams)
  },
  postDelete ({ searchIndex, dataRowsHasFlg, indexSelected }) {
    let param = {
      p_dteyreap: searchIndex.year,
      p_numtime: searchIndex.numtime
    }
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      param['p_codempid_query'] = dataRowsHasFlg[i]['codempid']
      dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.delete())
    return instance().post(endpoint + '/hrms17e/indexDelete', sendParams)
  },
  postDetail1TableDelete ({ searchIndex, dataRowsHasFlg, indexSelected }) {
    let param = {
      p_codempid_query: indexSelected.codempid,
      p_dteyreap: searchIndex.year,
      p_numtime: searchIndex.numtime
    }
    for (var i = 0; i < dataRowsHasFlg.length; i++) {
      dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
      dataRowsHasFlg[i].p_kpino = dataRowsHasFlg[i].kpino
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.delete())
    return instance().post(endpoint + '/hrms17e/detail1TableDelete', sendParams)
  },
  postImportKpi ({ searchIndex, dataHeader, dataRowsHasFlg }) {
    let sendParams = {}
    for (let i = 2; i < dataHeader.length; i++) {
      sendParams['item' + (i - 1)] = dataHeader[i].name
    }
    sendParams.p_dteyreap = searchIndex.year
    sendParams.p_numtime = searchIndex.numtime
    sendParams.param_json = JSON.stringify(dataRowsHasFlg)
    if (isMock) return generator(mocker.importKpi())
    return instance().post(endpoint + '/hrms17e/importKpi', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms17e/index.js